function nombreViaParaDireccion(nombreVia, tipoViaNombre) {
  const via = String(nombreVia || "").trim();
  const tipo = String(tipoViaNombre || "").trim();
  if (!via) return "";
  if (!tipo) return via;
  const vLow = via.toLowerCase();
  const tLow = tipo.toLowerCase();
  if (vLow === tLow || vLow.startsWith(`${tLow} `) || vLow.startsWith(`${tLow}.`)) {
    return via;
  }
  return `${tipo} ${via}`;
}

function numeroYaIncluidoEnVia(viaTexto, numero) {
  const via = String(viaTexto || "").trim();
  const num = String(numero || "").trim();
  if (!via || !num) return false;
  if (via.toLowerCase() === num.toLowerCase()) return true;
  const esc = num.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return new RegExp(`\\b${esc}\\s*$`, "i").test(via)
    || new RegExp(`\\bn[º°o.\\-]*\\s*${esc}\\s*$`, "i").test(via);
}

/** Construye la cadena de dirección para geocodificar o comparar cambios.
 * No incluye piso/puerta/bloque/escalera: Google los interpreta mal y mueve el pin
 * (p. ej. «Afrodita 9 PB I» → Les Marines en vez de Carrer Afrodita).
 * Pasar `incluirInterior: true` solo si se necesita el texto completo para mostrar.
 */
export function buildDireccionPropiedad(
  form,
  { tipoViaNombre, poblacionNombre, provinciaNombre, incluirInterior = false } = {},
) {
  const parts = [];
  const viaLinea = nombreViaParaDireccion(form?.nombre_via, tipoViaNombre);
  if (viaLinea) parts.push(viaLinea);
  const num = String(form?.numero || "").trim();
  if (num && !numeroYaIncluidoEnVia(viaLinea || form?.nombre_via, num)) {
    parts.push(num);
  }
  if (incluirInterior) {
    const extra = [form?.bloque, form?.escalera, form?.piso, form?.puerta]
      .filter(Boolean)
      .map((s) => String(s).trim())
      .join(" ");
    if (extra) parts.push(extra);
  }
  if (form?.codigo_postal) parts.push(String(form.codigo_postal).trim());
  if (poblacionNombre) parts.push(String(poblacionNombre).trim());
  if (provinciaNombre) parts.push(String(provinciaNombre).trim());
  parts.push("España");
  return parts.filter(Boolean).join(", ");
}

export function formatCoordenadas(lat, lng, dec = 6) {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return "";
  return `${la.toFixed(dec)}, ${ln.toFixed(dec)}`;
}

/** Parsea "38.84, 0.11" o "38.84 0.11" → { lat, lng }. */
export function parseCoordsInput(text) {
  const s = String(text || "").trim();
  if (!s) return null;
  const m = s.match(/(-?\d+(?:\.\d+)?)\s*[,;\s]\s*(-?\d+(?:\.\d+)?)/);
  if (!m) return null;
  const lat = parseFloat(m[1]);
  const lng = parseFloat(m[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

export function mapsUrlFromCoords(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return null;
  return `https://www.google.com/maps?q=${la},${ln}`;
}
